import { useSelector } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';
import UserAndTeamSearch from './UserAndTeamSearch';
import { getUserIdsWithPermissions, getUserIdToOwnerIdMap } from '../../selectors/ownersSelectors';
import { getUsersMap, getUsersToTeamsMap } from '../../selectors/usersSelectors';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { getCurrentUser } from '../../selectors/authSelectors';
import { getOwnersMap } from '../../selectors/ownersSelectors';
import { getViewableUsers } from '../../utils/userUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const UserAndTeamSearchContainer = ({
  teams,
  canViewAll,
  canViewTeam,
  handleSelectUserOrTeam,
  userPrimaryTeam
}) => {
  const currentUserId = useSelector(getCurrentUser).user_id;
  const isDealStageView = useSelector(getIsDealStageView);
  const ownersMap = useSelector(getOwnersMap);
  const userIdToOwnerIdMap = useSelector(getUserIdToOwnerIdMap);
  const userIdsWithPerms = useSelector(getUserIdsWithPermissions);
  const usersMap = useSelector(getUsersMap);
  const usersToTeamMap = useSelector(getUsersToTeamsMap);
  const viewableUsers = getViewableUsers({
    canViewAll,
    canViewTeam,
    currentUserId,
    userPrimaryTeam: ImmutableMap(userPrimaryTeam),
    teams,
    userIdsWithPerms
  });
  const teamsForSearch = teams.toList();
  return /*#__PURE__*/_jsx(UserAndTeamSearch, {
    "aria-labelledby": "rep-filter-team-label",
    buttonUse: "transparent",
    handleSelectUserOrTeam: handleSelectUserOrTeam,
    isDealStageView: isDealStageView,
    menuWidth: 300,
    ownersMap: ownersMap,
    teams: teamsForSearch,
    userIdToOwnerIdMap: userIdToOwnerIdMap,
    userIdsWithPerms: viewableUsers,
    usersMap: usersMap,
    usersToTeamMap: usersToTeamMap
  });
};
export default UserAndTeamSearchContainer;